import React, { forwardRef } from 'react';
import Sources from './components/Sources';
import Subtitles from './components/Subtitles';
import { VideoProps } from './types';

const Video = forwardRef<HTMLVideoElement, VideoProps>(
  (
    {
      className,
      controls = true,
      source = [],
      poster = '',
      preload = '',
      autoPlay = false,
      width = '100%',
      objectFit = 'cover',
      style,
      subtitles = [],
      ...restProps
    },
    ref
  ) => (
    <video
      className={className}
      style={{ objectFit, ...style }}
      ref={ref}
      autoPlay={autoPlay}
      controls={controls}
      poster={poster}
      preload={preload}
      crossOrigin="anonymous"
      role="video"
      width={width}
      {...restProps}
    >
      <Sources sources={source} />
      <Subtitles subtitles={subtitles} />
    </video>
  )
);

Video.displayName = 'Video';

export default Video;
